import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { SidebarButtonDirective } from '../buttons/sidebar-button/sidebar-button.component';
import { ISideBarButtons } from '../../interfaces/ISidebarMenu';
import { Overview } from '../../abstract/Overview';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'right-sidebar-menu',
  standalone: true,
  imports: [
    CommonModule,
    SidebarButtonDirective,
    MatButtonModule
  ],
  templateUrl: './right-sidebar-menu.component.html',
  styleUrl: './right-sidebar-menu.component.scss'
})
export class RightSidebarMenuComponent extends Overview implements OnInit{
  ngOnInit(): void {
    this.isOverviewActive = true;
  }
  @Input() sideBarButtonsTop!: ISideBarButtons[];
  @Input() sideBarButtonsBottom!: ISideBarButtons[];

  isButtonActive(sidebarButton: ISideBarButtons) {
    return !sidebarButton.disabled && !!sidebarButton.isActive?.();
  }
}
